module.exports = __webpack_public_path__ + "img/4-l.a2537406.png";